export const isNullOrEmpty = (message: string) => {
  if (!message) {
    return true;
  }

  if (message.length === 0) {
    return true;
  }

  return false;
};
